type TabEmptyStateProps = {
  message: string;
};

export const TabEmptyState = ({ message }: TabEmptyStateProps) => (
  <div className="flex items-center justify-center py-8 text-s-r text-base-25">{message}</div>
);
